// @TODO: this could maybe be mostly replaced with a gif of the whole background/storm
/**
 * Ryan O'Dowd
 * 2024-10-09
 * © Copyright 2024 Oakwood Software Consulting, Inc. All Rights Reserved.
 */
import Animated, {
  interpolateColor,
  useAnimatedStyle,
  useSharedValue,
  withTiming,
} from 'react-native-reanimated';
import {
  AppState,
  ImageBackground,
  Platform,
  View,
} from 'react-native';
import React, {
  useCallback,
  useEffect,
  useMemo,
  useRef,
} from 'react';
/* @TODO:
import Sound, {
  ThunderMp3,
} from './Sound';
*/
// @TODO: import fb from '@utils/firebase';
import getStyles from './styles';
import hooks from '@hooks';

const RAIN_GIF = require('@assets/img/rain.gif');

const LightningBackground = (props: LightningBackgroundProps) => {
  const styles = hooks.useStyles(getStyles);

  const lightningColors = [styles.colors.primaryDark, styles.colors.primaryExtraLight];

  const backgroundOpacity = useSharedValue(props.initialOpacity);
  const backgroundColor = useSharedValue(0);

  const stormIsLightningOn = hooks.useTypedSelector((state) => state.stormIsLightningOn);
  const stormIsRainOn = hooks.useTypedSelector((state) => state.stormIsRainOn);
  const stormIsThunderOn = hooks.useTypedSelector((state) => state.stormIsThunderOn && state.theme === 'storm');

  const appState = useRef(AppState.currentState);

  const animatedStyle = useAnimatedStyle(() => {
    const themeColor = interpolateColor(
      backgroundColor.value,
      [0, 1],
      lightningColors,
    );

    return {
      position: 'absolute',
      top: 0,
      left: 0,
      flex: 1,
      width: styles.windowWidthRaw,
      height: styles.windowHeight,
      opacity: backgroundOpacity.value,
      backgroundColor: themeColor,
    };
  });

  const bgSfx = useMemo(() => {
    if (Platform.OS === 'web') {
      return;
    }

    return; // @TODO: yeet...put sound back on native

    /* @TODO:
    return new Sound(ThunderMp3, (error) => { // @TODO: should loop better
      if (error) {
        fb.log(fb.crashlytics, `failed to load the sound: ${error}`);
        fb.recordError(fb.crashlytics, error);
        return;
      }

      // Reduce the volume
      bgSfx.setVolume(0.5);

      // Loop indefinitely until stop() is called
      bgSfx.setNumberOfLoops(-1);
    });
    */
  }, []);

  const playThunder = useCallback(() => {
    if (Platform.OS === 'web') {
      return;
    }

    return; // @TODO: yeet...put sound back on native

    /* @TODO:
    if (!stormIsThunderOn || appState.current !== 'active') {
      bgSfx.stop();
      return;
    }

    setTimeout(() => { // @TODO: this is a little hacky, but it seems that this timeout is required to make sure that the sound has been loaded
      bgSfx.play();
      bgSfx.setCurrentTime(new Date().getSeconds() % 30); // match wall time to match thunder with the lightning
    }, 100);
    */
  }, []);

  useEffect(() => {
    if (Platform.OS === 'web') {
      return;
    }

    return; // @TODO: yeet...put sound back on native

    /* @TODO:
    playThunder();

    return () => {
      bgSfx.stop();
    };
    */
  }, [stormIsThunderOn, playThunder, bgSfx]); // @TODO: is having stormIsThunderOn really the best way to retrigger playThunder?

  useEffect(() => {
    const subscription = AppState.addEventListener('change', (nextAppState) => {
      appState.current = nextAppState;
      playThunder();
    });

    return () => {
      subscription.remove();
    };
  }, [playThunder]);

  useEffect(() => {
    if (!stormIsLightningOn) {
      backgroundOpacity.value = props.initialOpacity;
      backgroundColor.value = 0;
      return;
    }

    const lightningIntervalSeconds = 30; // @TODO: current length of mp3 file
    const animateLightning = () => {
      const onBreak = ![1, 4, 6].includes(new Date().getSeconds() % lightningIntervalSeconds); // lightning should come right before thunder
      const skipThisFlash = Math.random() < 0.2;

      if (onBreak || skipThisFlash) {
        backgroundOpacity.value = props.initialOpacity;
        backgroundColor.value = 0;
        return;
      } // else ~luigi has appeared~ we can animate the lightning

      const randomOpacity = Math.random() * 0.5;

      const onDuration = Math.random() * 50 + 50; // 50-100ms
      const offDuration = Math.random() * 50; // 0-50ms
      backgroundOpacity.value = withTiming(randomOpacity, {duration: onDuration}, () => {
        backgroundOpacity.value = withTiming(props.initialOpacity, {duration: offDuration});
        backgroundColor.value = withTiming(Math.random() > 0.5 ? 1 : 0, {duration: 100});
      });
    };

    const intervalId = setInterval(() => {
      animateLightning();
    }, 200);

    // Cleanup both intervals on component unmount
    // @TODO: also clearinterval on app background
    return () => clearInterval(intervalId);
  }, [props.initialOpacity, backgroundOpacity, backgroundColor, stormIsLightningOn]);

  return (
    <View style={styles.container}>
      <Animated.View style={[animatedStyle]} />

      {stormIsRainOn && (
        <ImageBackground
          style={styles.backgroundImageWrapper}
          imageStyle={styles.rain}
          source={RAIN_GIF}
        />
      )}
    </View>
  );
};

class LightningBackgroundProps {
  initialOpacity: number;
};

export default LightningBackground;
